import React, { useContext, useEffect, useState } from 'react'
import LoggedInLayout from '../../layout/LoggedInLayout'
import { Box, Grid2, Typography, useMediaQuery, useTheme } from '@mui/material'
import UserInfoCard from './UserInfoCard'
import Breadcrumb from '../common/Breadcrumb'
import Chatbot from '../common/Chatbot'
import httpcommon from '../../helper/httpcommon'
import { useToast } from '../../hook/useToast'
import AuthContext from '../../context/AuthContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CommonButtonActionButton from '../common/CommonButtonActionButton'

const ChatwithAi = () => {
    const navigate = useNavigate();
    const [userInfoToggle, setUserInfoToggle] = useState(true)
    const [triggerNewConversion, setTriggerNewConversion] = useState(null)
    const [student, setStudent] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultTest = searchParams.get("test_type") || "adaptive";
    const [selectSubject, setSelectSubject] = useState(defaultTest)


    const handleSubjectChange = (e) => {
        const newValue = e.target.value;
        setSelectSubject(newValue);
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set("test_type", newValue);
            return params;
        });
    };
    // Inside component state:
    const [expertFormData, setExpertFormData] = useState({
        name: '',
        career: '',
        email: '',
        phone: ''
    });

    const handleExpertSubmit = () => {
        console.log("Form submitted");
        setExpertModalOpen(false);
    };
    const userInfoToggleFunction = () => {
        e.stopPropagation();
        setUserInfoToggle(!userInfoToggle)

    }
    function onNewConversionClick() {
        if (triggerNewConversion == null) {
            setTriggerNewConversion(true)
        }
        else {
            setTriggerNewConversion(!triggerNewConversion)
        }


    }

    const fetchStudent = async () => {
        try {
            setLoading(true);
            const response = await httpcommon.get("school/student/profile/");
            if (response.status === 200) {
                const data = response.data;
                setStudent({
                    school_name: data.school || "",
                    board: data.board,
                    board_name: data.board || "",
                    class: data.student_class || "",
                    section: data.section || "A",
                    roll_number: data.roll_number || "1",
                    birth_date: data.birth_date || "",
                    contact_number: data.contact_number || "",
                    address: data.address || "",
                    student_name: data.user_name || "",
                    avatar: data.avatar || "",
                    profileCompletion: data.profile_completion || 0,
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchStudent();

    }, []);
    const options = [
        { value: 'adaptive', label: 'Aptitude Test' },
        { value: 'personality', label: 'Self Introspection' },
        { value: 'general', label: 'Help us know you' },

    ]
    const selectedOption = options.find(opt => opt.value === selectSubject);

    const theme = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down("md")); // Check if the screen is md or smaller
    return (
        <LoggedInLayout>
            <div className="chatbot-page">
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Box>
                        {/* <p className='page-heading'>Council / Chatbot</p>
                                                <p className='page-heading'>Council / Chatbot</p> */}

                        <Breadcrumb

                            breadcrumbs={[
                                { label: 'Career Counselling', path: '/council' },
                                { label: selectedOption.label } // no path means current page
                            ]}></Breadcrumb>
                    </Box>

                </Box>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" }, gap: 4 }}>
                    {/* Left panel (User Info) */}
                    <Box
                        sx={{
                            flexBasis: { lg: userInfoToggle ? "25%" : "8%" }, // 3/12 ≈ 25%, 1/12 ≈ 8%
                            width: "100%",
                        }}
                    >
                        <UserInfoCard
                            selectSubject={selectSubject}
                            handleSubjectChange={handleSubjectChange}
                            student={student}
                            subjectOptions={options}
                            isLoading={isLoading}
                            userInfoToggle={userInfoToggle}
                            onCollapes={userInfoToggleFunction}
                            onNewConversionClick={onNewConversionClick}
                        />
                    </Box>

                    {/* Right panel (Chatbot) */}
                    <Box
                        sx={{
                            flexGrow: 1,
                            flexBasis: { lg: userInfoToggle ? "75%" : "92%" }, // 9/12 ≈ 75%, 11/12 ≈ 92%
                            width: "100%",
                        }}
                    >
                        <Chatbot

                            selectSubject={selectSubject}
                            student={student}
                            onCollapes={userInfoToggleFunction}
                            userInfoToggle={userInfoToggle}
                            triggerNewConversion={triggerNewConversion}
                        />
                    </Box>
                </Box>
            </div>
        

        </LoggedInLayout>
    )
}

export default ChatwithAi